import React from 'react'

export default () => {

  const skipLink = {
    selector: `main.body a, main.body button:not(:disabled), main.body input:not(:disabled), main.body select:not(:disabled), main.body textarea:not(:disabled), main.body [tabIndex]:not([tabIndex="-1"]):not([tabIndex=""])`,
    label: 'main content'
  }
  const setFocus = () => {
    const focusable = document.querySelector(skipLink.selector)
    if (focusable) {
      focusable.focus()
    }
  }
  const handleKeyPress = e => {
    if(e.keyCode === 32 || e.keyCode === 13) {
      e.preventDefault()
      setFocus()
    }
  }
  const handleClick = (e) => {
    e.preventDefault()
    setFocus()
    return false;
  }
  return (
      <a
        tabIndex="1"
        onKeyDown={handleKeyPress}
        className="skip-link"
        href=""
        onClick={handleClick}
        >
          Skip to {skipLink.label}
      </a>
  )
}



// WEBPACK FOOTER //
// ./src/components/SkipLink/SkipLink.js